import * as React from 'react';
import { XYChart, Tooltip, AxisBottom, AxisLeft, Grid } from '../xychart';
import { useGetLeftAxisLabelOffset } from '../bar-graph/utils/use-calculate-left-axis-label-offset';
import { LinePath } from '../xychart/components/line-path';
import { Circles } from '../xychart/components/circles';
import * as LineGraph from './types/line-graph';

const NUM_Y_TICKS = 5;

export function MasonryLineGraph<Datum>({
  data,
  accessors,
  title,
  description,
  axisLeftLabel,
  ariaDatumLabel,
  axisBottomLabel,
  renderTooltip,
  pointPadding,
  yAxisMax,
  xAxisTicks,
  xAxisLabelTicks,
  xAxisTickFormat,
  datumsPerColumn: datumsPerColumnProp,
}: LineGraph.MasonryLineGraph<Datum>) {
  const yAxisLabelOffset = useGetLeftAxisLabelOffset(yAxisMax);
  const [leftMargin, setLeftMargin] = React.useState(0);
  const [bottomMargin, setBottomMargin] = React.useState(0);
  const datumsPerColumn =
    datumsPerColumnProp ??
    (xAxisTicks?.length ? Math.round(data.length / xAxisTicks.length) : 1);

  return (
    <XYChart
      title={title}
      desc={description}
      data={data}
      accessors={accessors}
      margin={{
        left: leftMargin,
        bottom: bottomMargin,
      }}
      xScale={{
        type: 'point',
        padding: pointPadding,
      }}
      yScale={{
        type: 'linear',
        domain: [0, yAxisMax],
      }}
    >
      <Grid
        numTicksRows={NUM_Y_TICKS}
        columnTickValues={xAxisTicks}
        centerColumns
        datumsPerColumn={datumsPerColumn}
      />
      <AxisLeft
        label={axisLeftLabel}
        labelOffset={yAxisLabelOffset}
        numTicks={NUM_Y_TICKS}
        hideTicks
        onWidthChange={(width) => setLeftMargin(width)}
      />
      <AxisBottom
        label={axisBottomLabel}
        tickValues={xAxisLabelTicks ?? xAxisTicks}
        tickFormat={xAxisTickFormat}
        onHeightChange={(height) => setBottomMargin(height)}
      />
      <LinePath accessors={accessors} data={data} />
      <Circles
        ariaDatumLabel={ariaDatumLabel}
        accessors={accessors}
        data={data}
      />
      <Tooltip<Datum> snapToDatum>{renderTooltip}</Tooltip>
    </XYChart>
  );
}
